

































import { Component, Prop, Vue, Emit, Watch, Mixins } from 'vue-property-decorator';
import { Company } from '../models';
import { addItemToLocalStorage, Method, OptionalCompanyID, StoregeKey } from '../utils';
import Multiselect from 'vue-multiselect';
import { Mounted } from '../decorators';
import {
    AuthStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    StoreHelper,
    VehicleCompanyStoreHelper
} from '../mixins';

@Component({
    components: { Multiselect }
})
export default class SelectCompany extends Mixins(
    StoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    NotificationStoreHelper,
    AuthStoreHelper
) {
    @Prop() companies: Company[];
    @Prop() companySelected: Company;
    @Prop() select: Company;
    @Prop() setSelectedCompany: Method<OptionalCompanyID, void>;
    @Prop({ default: false }) isMock: boolean;
    isOpen: boolean = false;
    filteredCompanies: Company[] = [];
    searchedCompany: any = '';

    get getCompanySelected() {
        return this.companySelected;
    }

    get companiesAreLoaded() {
        return this.companies.length !== 0 ? true : false;
    }

    @Emit()
    searchCompany(value: boolean) {}

    @Watch('companySelected')
    observableCompanySelected() {
        this.searchedCompany = this.companySelected;
    }

    @Watch('companies')
    observableCompanies() {
        this.filteredCompanies = this.companies;
        this.setCompanies();
        this.setCompanySelected(this.companySelected);
        // window.console.log("1", this.companySelected);
        this.sortFilteredCompanies(this.companySelected);
    }

    get selectComponent(): any {
        return this.$refs.selectComponent as any;
    }

    setCompanySelected(value) {
        if (value !== null) {
            addItemToLocalStorage(StoregeKey.COMPANY, value)
        }
    }

    handleSelectedCompany(selectedCompany: Company) {
        if (!this.isMock) {
            this.searchedCompany = selectedCompany;
            this.setCompanySelected(selectedCompany);
            this.setSelectedCompany(selectedCompany.id);
            this.sortFilteredCompanies(this.searchedCompany);

            // this.$_setSelectedVehicles([])
        }
    }

    handleChange(): void {
        this.selectComponent.blur();
        this.searchCompany(false);
    }

    handleOpen(): void {
        this.isOpen = true;
        this.searchCompany(true);
    }

    handleClose(): void {
        this.isOpen = false;
        this.searchCompany(false);
    }

    searchChange(searchQuery: string, id: any) {
        if (searchQuery) {
            this.filteredCompanies = this.companies.filter(company => this.filterHandler(company, searchQuery));
        } else {
            this.filteredCompanies = this.companies;
        }
        if (this.searchedCompany) {
            this.sortFilteredCompanies(this.searchedCompany);
        }
    }

    filterHandler(company: Company, queryText: string): boolean {
        let queryTextLowerCase = queryText.toLocaleLowerCase();
        return (
            company.id
                .toString()
                .toLocaleLowerCase()
                .includes(queryTextLowerCase) || company.name.toLocaleLowerCase().includes(queryTextLowerCase)
        );
    }

    sortFilteredCompanies(selectedCompany: Company): void {
        if (selectedCompany && selectedCompany.id !== null) {
            this.filteredCompanies = this.filteredCompanies.sort((a, b) => {
                //  window.console.log(selectedCompany);
                return selectedCompany.id == a.id ? -1 : selectedCompany.id == b.id ? 1 : a.name > b.name ? 1 : -1;
            });
        }
    }

    setCompanies(): void {
        this.filteredCompanies = this.companies;
        this.searchedCompany = this.companySelected;
    }
}
